<script lang="ts">
import { defineComponent, computed } from 'vue'

export default defineComponent({
  props: {
    nuxt2meta: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const convertedMeta = computed(() => convertMeta(props.nuxt2meta))
    useHead(convertedMeta)
    return {}
  },
  render() {
    return null
  },
})

function convertMeta(nuxt2meta: any) {
  const script = (nuxt2meta?.script || []).map(processScript)
  return { ...nuxt2meta, script }
}

function processScript(item: any) {
  if (item.type === 'application/ld+json' && item.body && item.json) {
    item.innerHTML = JSON.stringify(item.json)
    delete item.json
  }
  return item
}
</script>
